import React,{useEffect} from 'react'
import "./about.css";
import { motion } from "framer-motion";

export default function About() {
  const testimonials = [
    {
      name: "TechNova Solutions",
      role: "Software Engineer",
      text: "STRATEGIC HIRE transformed our hiring process! Previously, screening candidates took weeks, but now we get top-quality shortlists in hours. The AI-driven insights helped us find the perfect matches effortlessly. Highly recommended!",
      image: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    {
      name: " SwiftFinance Inc",
      role: "HR Manager",
      text: "Finding skilled professionals in the finance sector has always been a challenge. STRATEGIC HIRE not only saved us time but also ensured that our hires were the best fit for our company culture. A game-changer in recruitment!",
      image: "https://randomuser.me/api/portraits/women/44.jpg"
    },
    {
      name: "HealthCare Plus",
      role: "Tech Lead",
      text: "As a growing healthcare provider, we needed a recruitment solution that understood our industry’s unique needs. STRATEGIC HIRE’s AI-powered hiring simplified the process and helped us onboard highly qualified professionals seamlessly!",
      image: "https://randomuser.me/api/portraits/men/50.jpg"
    }
  ];
    useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Get scroll position
      const aboutBackground = document.querySelector(".about-sec .background");
      const missionBackground = document.querySelector(".our-mission .mis-background");
      const workBackground = document.querySelector(".work .background");
      const testimonialsBackground = document.querySelector(".testimonials .background");
      const invitationBackground = document.querySelector(".invitation .background");
      
      // if (aboutBackground) {
      //   aboutBackground.style.transform = `translateX(${scrollY * -0.2}px) translateY(${scrollY * -0.1}px)`;
      // }
      
      // if (missionBackground) {
      //   missionBackground.style.transform = `translateX(${scrollY * 0.2}px) translateY(${scrollY * 0.1}px)`;
      // }

      // if (workBackground) {
      //   workBackground.style.transform = `translateX(${scrollY * -0.15}px) translateY(${scrollY * 0.1}px)`;
      // }
      // if (testimonialsBackground) {
      //   // Keep the movement in sync with the previous sections
      //   testimonialsBackground.style.transform = `translateX(${scrollY * 0.2}px) translateY(${scrollY * 0.1}px)`;
      // }
      // if (invitationBackground) {
      //   // invitationBackground.style.transform = `translateX(${scrollY * -0.18}px) translateY(${scrollY * 0.08}px)`;
      //   invitationBackground.style.transform = `translateX(${scrollY * -0.15}px) translateY(${scrollY * 0.1}px)`;

      // }

    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div className='About'>

      <div className='about-sec'>
      <div className="background">
        <img src="/assests/images/front.jpg" alt="Front" />
      </div>
        <div className='content'>
        <h1>STRATEGIC HIRE: Revolutionizing Hiring with Intelligence</h1>
        <h4>
        At STRATEGIC HIRE, we’re redefining how organizations find talent. Powered by cutting-edge artificial intelligence, we streamline the hiring process, saving time and ensuring the perfect match between employers and candidates.
        </h4>
        </div>
      </div>

      <div className='our-mission'>
      <div className="background">
        <img src="/assests/images/mission.jpg" alt="Mission" />
      </div>
      <div className='content'>
           <h1>Our Mission</h1>
           <h4>Our mission is to make hiring effortless, efficient, and equitable. We leverage AI to eliminate bias, reduce manual effort, and connect organizations with top-tier talent—faster than ever before</h4>
        </div>
        <div className='mis-background'></div>
      </div>

      <div className='work'>
      <div className="background">
        <img src="/assests/images/work.jpg" alt="Work" />
      </div>
      <div className='content'>
        <h1>How It Works?</h1>
        <ul>
        <li>Sign up, drop jobs.</li>
        <li>Candidates jump in.</li>
        <li>ATS picks the best.</li>
        <li>AI interviews, decides fast.</li>
        <li>Hired or bounced, done.</li>
        </ul>
      </div>
      </div>

      <div className="testimonial-section">
      <h2>What People Say!</h2>
      <div className="testimonial-container">
        {testimonials.map((testimonial, index) => (
          <motion.div 
            key={index} 
            className="testimonial-card"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <img src={testimonial.image} alt={testimonial.name} className="testimonial-img" />
            <p className="testimonial-text">"{testimonial.text}"</p>
            <h4 className="testimonial-name">{testimonial.name}</h4>
            <p className="testimonial-role">{testimonial.role}</p>
          </motion.div>
        ))}
      </div>
    </div>


      <div className='invitation'>
      <div className="background">
        <img src="/assests/images/invite.jpg" alt="Work" />
      </div>
        <div className='content'>
            <h1>Ready to transform your hiring process?          </h1>
            <h4> Partner with STRATEGIC HIRE today and experience recruitment, redefined.</h4>
        </div>
      </div>
  </div>
  )
}
